import HttpClient from "../base/http-client";

export default class GroupClient extends HttpClient {
  constructor() {
    super("groups");
    this.isAuth = true;
  }
}
